




















import { State, Getter, Action } from 'vuex-class';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from '@/functions/debounce';
import { SortOrder } from '@/enums/SortOrder';
import { Searchable } from '@/mixins/searchable';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    TableBase: () => import('@/components/table/base.vue'),
    IndexSearch: () => import('@/components/parts/IndexSearch.vue'),
  },
})
export default class PageProducts extends Searchable<Product> {
  @Getter('product/all') products!: Product[];

  @Getter('workspace/selected') workspace!: Workspace;

  @Action('product/index') indexProducts!: (payload?: { query?: IndexQuery<Product>; workspaceId: number }) => Promise<Product[]>;

  localProducts: Product[] = [];

  i18n: string = 'views.products.index';

  searchItemsProperty = 'products';

  tableLayout = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 136px)',
      clickable: true,
    },
    structure: [
      {
        key: 'id',
        value: (model: Product) => `#${model.id}`,
        width: 75,
      },
      { key: 'name', width: 350 },
      {
        key: 'status',
        style: (model: Product) => {
          if (model.status === 'published') {
            return {
              color: 'var(--color-green)',
              fontSize: '12px',
              letterSpacing: '0',
              lineHeight: '15px',
              padding: '2px 6px',
              borderRadius: '2px',
              backgroundColor: 'var(--color-green)20',
              border: '1px solid var(--color-green)90',
            };
          } else {
            return {
              color: '#6C727A',
              fontSize: '12px',
              letterSpacing: '0',
              lineHeight: '15px',
              padding: '2px 6px',
              borderRadius: '2px',
              backgroundColor: '#F5F5F5',
              border: '1px solid #DEDFE3',
            };
          }
        },
      },
      { key: 'stock', value: (model: Product) => model.variants.map((variant) => variant.stock).reduce((previousStock, stock) => previousStock + stock, 0), sortable: false },
    ],
  };

  @Debounce(500)
  handleSearch(searchText: string) {
    this.searchText = searchText;
    this.indexProducts({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  handleSort(item: any) {
    this.sorting = item;
    this.indexProducts({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  loadMore() {
    this.indexProducts({ query: { q: this.searchQuery, after: this.lastAfter, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  @Watch('products', { immediate: true })
  productsChanged(val: Product[]) {
    this.localProducts = val;
  }

  @Watch('workspace')
  workspaceChanged(val: Workspace) {
    this.indexProducts({ query: { per_page: 20 }, workspaceId: val.id });
  }
}
